export function PrimaryColor() {
    return { color: 'white',background: '#075E54' };
}
  